module.exports = __webpack_public_path__ + "assets/img/thumb-Betashares-Explainer-Animation-Video.ca47c2fa.webp";